import React, { FC } from 'react';

import { Box } from '@material-ui/core';
import cx from 'classnames';

import { IKImage } from '../IKImage';
import useStyles from './styles';

interface LoaderProps {
  global?: boolean;
  loaderContainerClass?: string;
}

const Loader: FC<LoaderProps> = ({ global = true, loaderContainerClass = '', children }) => {
  const classes = useStyles(global)();
  return (
    <div className={classes.pageLoaderPro}>
      <Box className={classes.centerLoader}>
        <Box className={cx(classes.customLoader, loaderContainerClass)}>
          <IKImage
            path="/logo-animation/fu-logo-1.png"
            className={classes.customLoaderImg}
            alt="logo-animation"
          />
          <IKImage
            path="/logo-animation/fu-logo-2.png"
            className={cx(classes.customLoaderImg, 'fuLogo2')}
            alt="logo-animation"
          />
          <IKImage
            path="/logo-animation/fu-logo-3.png"
            className={cx(classes.customLoaderImg, 'fuLogo3')}
            alt="logo-animation"
          />
        </Box>
        {children}
      </Box>
    </div>
  );
};
export default Loader;
